import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ScreeningAlert} from "../../../../model/lookup-results.model";
import {DataEntry} from "../../../../model/fields.model";
import {LookupService} from "../../lookup.service";
import {TranslateService} from "@ngx-translate/core";

declare var bootstrap: any;

@Component({
  selector: "admin-lookup-common-checks",
  templateUrl: "./checks.component.html",
  styleUrls: ["./checks.component.css"]
})
export class AdminLookupCommonChecksComponent {

  @Input() alert: ScreeningAlert = new ScreeningAlert();

  @Output() titleEmitter = new EventEmitter<string>();

  constructor(
    private singleService: LookupService,
  ) {
  }

  view(event: MouseEvent, alert: ScreeningAlert) {
    event.stopPropagation();
    this.singleService.viewEntry(this.titleEmitter, alert);
  }

  riskClass(alert: ScreeningAlert) {
    if (alert.risk == "high") {
      return "danger";
    } else if (alert.risk == "medium") {
      return "warning";
    } else if (alert.risk == "low") {
      return "success";
    }
    return "danger";
  }

  bestScore(alert: ScreeningAlert): number | undefined {
    const scores = alert.hits
      .map(hit => hit.score)
      .filter((score): score is number => score !== undefined);

    return scores.length > 0 ? Math.max(...scores) : undefined;
  }

  worstScore(alert: ScreeningAlert): number | undefined {
    const scores = alert.hits
      .map(hit => hit.score)
      .filter((score): score is number => score !== undefined);

    return scores.length > 0 ? Math.min(...scores) : undefined;
  }

}
